<template>
  <n-alert
    v-if="!supported"
    type="warning"
    closable
    :bordered="false"
    :show-icon="false"
    class="browser-supported"
  >
    <i class="icon iconfont warning">&#xe63d;</i>
    <span class="text">{{ $t('Tips_Low_version') }}</span>
    <a
      class="pointer link"
      :href="
        useSSOStore().currentLocale === 'en'
          ? `https://${DomainManager.getTargetDomain('help', { region: 'hk' })}/bin/view/Egret%20Cloud%20Operation%20manual/`
          : `https://${DomainManager.getTargetDomain('help')}/bin/view/Main/`
      "
      target="_blank"
      :style="{ marginLeft: '4px', marginRight: '4px' }"
    >
      {{ $t('Tips_Operation_documentation') }}
    </a>
    <span class="text">{{ $t('Tips_Learn_more') }}</span>
  </n-alert>
</template>

<script setup lang="ts">
import { $t } from '@/i18n'
import { useSSOStore } from '@/store'
import { DomainManager } from '@kuailu/sso'

const supported = ref<boolean | string>(true)
function detectBrowser() {
  const ua = navigator.userAgent
  console.log(`%c UserAgent: ${ua}`, 'color: #fff; background: #b457ff;')

  let browserName = ''
  let version = 0
  const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1 // 判断是否是 android终端
  if (isAndroid) {
    browserName = 'Android Browser'
    const androidMatch = ua.match(/Android\s*(\d+(\.\d+)*)/)
    console.log(androidMatch)
    if (androidMatch) {
      version = parseInt(androidMatch[1], 10)
    }
    return `Browser: ${browserName}, Version: ${version} (Supported)`
  }
  const isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // 判断是否是 iOS
  if (isIOS) {
    const safariMatch = ua.match(/Version\/(\d+(\.\d+)?)/)
    browserName = 'iOS-Safari'
    if (safariMatch) {
      version = parseInt(safariMatch[1], 10)
    }
    return `Browser: ${browserName}, Version: ${version} (Supported)`
  }

  // 检测 Edge
  const edgeMatch = ua.match(/Edg\/(\d+)/)
  if (edgeMatch) {
    browserName = 'Edge'
    version = parseInt(edgeMatch[1], 10)
    if (version >= 90) {
      return `Browser: ${browserName}, Version: ${version} (Supported)`
    }
  }

  // 检测 Chrome
  const chromeMatch = ua.match(/Chrome\/(\d+)/)
  if (chromeMatch) {
    browserName = 'Chrome'
    version = parseInt(chromeMatch[1], 10)
    if (version >= 90) {
      return `Browser: ${browserName}, Version: ${version} (Supported)`
    }
  }

  // 检测 Safari
  const safariMatch = ua.match(/Version\/(\d+(\.\d+)?)/)
  if (safariMatch && ua.includes('Safari') && !ua.includes('Chrome')) {
    browserName = 'Safari'
    version = parseInt(safariMatch[1], 10)
    if (version >= 14) {
      return `Browser: ${browserName}, Version: ${version} (Supported)`
    }
  }

  // 检测 Firefox
  const firefoxMatch = ua.match(/Firefox\/(\d+)/)
  if (firefoxMatch) {
    browserName = 'Firefox'
    version = parseInt(firefoxMatch[1], 10)
    if (version >= 90) {
      return `Browser: ${browserName}, Version: ${version} (Supported)`
    }
  }

  console.log(
    `%c Browser not supported or version is too low.`,
    'color: #ffffff; background: #F53F3F;'
  )
  return false
}
supported.value = detectBrowser()
console.log(`%c ${supported.value}`, 'color: #ffffff; background: #00B42A;')
</script>
<style lang="scss">
.browser-supported {
  .n-alert-body {
    padding-top: 11px;
    padding-bottom: 11px;

    .n-alert-body__content {
      text-align: center;
      line-height: 22px;
      height: 22px;
    }

    .icon {
      color: #f0a020;
      margin-right: 8px;
      font-size: 20px;
    }

    .icon,
    .text,
    .link {
      vertical-align: text-bottom;
      display: inline-block;
    }

    .link {
      color: #0e67da;
    }
  }
}
</style>
